var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.94 0 0 8.94 0 20C0 31.06 8.94 40 20 40C31.06 40 40 31.06 40 20C40 8.94 31.06 0 20 0ZM28.6 28.6C27.82 29.38 26.56 29.38 25.78 28.6L20 22.82L14.22 28.6C13.44 29.38 12.18 29.38 11.4 28.6C10.62 27.82 10.62 26.56 11.4 25.78L17.18 20L11.4 14.22C10.62 13.44 10.62 12.18 11.4 11.4C12.18 10.62 13.44 10.62 14.22 11.4L20 17.18L25.78 11.4C26.56 10.62 27.82 10.62 28.6 11.4C29.38 12.18 29.38 13.44 28.6 14.22L22.82 20L28.6 25.78C29.36 26.54 29.36 27.82 28.6 28.6Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ca8ff50b5c3921f805c4be9b7df13ff4.svg";
export { ForwardRef as ReactComponent };